import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft, Clock } from "lucide-react";
import api from "../lib/api";
import { useLang } from "../context/LanguageContext";
import { Overline } from "../components/site/Reveal";
import { sanitizeHtml } from "../lib/sanitize";
import FocalImage from "../components/FocalImage";

export default function BlogDetail() {
  const { id } = useParams();
  const { lang, t } = useLang();
  const navigate = useNavigate();
  const [m, setM] = useState(null);

  useEffect(() => { api.get(`/media/${id}`).then((r) => setM(r.data)).catch(() => setM(false)); }, [id]);

  if (m === false) return <div className="max-w-3xl mx-auto px-5 py-40 text-center font-display text-3xl text-primary/50">{t("Article not found.", "Article introuvable.")}</div>;
  if (!m) return <div className="min-h-[60vh] flex items-center justify-center font-display text-3xl text-primary/40 animate-pulse">GYBC</div>;

  const title = lang === "fr" ? m.title_fr : m.title_en;
  const body = (lang === "fr" ? m.body_html_fr : m.body_html_en) || "";
  const excerpt = lang === "fr" ? m.excerpt_fr : m.excerpt_en;

  return (
    <article data-testid="blog-detail-page" className="max-w-3xl mx-auto px-5 md:px-8 py-8 md:py-14">
      <button onClick={() => navigate("/media")} className="flex items-center gap-2 text-sm text-primary/60 hover:text-secondary mb-6"><ArrowLeft size={16} /> {t("Back to media", "Retour aux médias")}</button>
      <Overline>{m.category}</Overline>
      <h1 className="font-display text-4xl md:text-6xl font-medium tracking-tight mt-3 text-primary leading-[1.05]">{title}</h1>
      <div className="flex items-center gap-2 text-sm text-muted-foreground mt-4"><Clock size={14} className="text-secondary" /> {m.read_time}</div>
      {m.image && <div className="rounded-[2rem] overflow-hidden mt-8 aspect-[16/9]"><FocalImage img={{ url: m.image, ...(m.image_focal || {}) }} alt="" /></div>}
      {body ? (
        <div className="prose-article mt-8" dangerouslySetInnerHTML={{ __html: sanitizeHtml(body) }} />
      ) : (
        <p className="text-lg text-foreground/70 leading-relaxed mt-8">{excerpt}</p>
      )}
    </article>
  );
}
